import React, { useState } from "react";
import apps from "./apps";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TreeHole from "./TreeHole.js";

export default function App() {
  const [keyword, setKeyword] = useState("");

  const openApp = (url) => {
    window.location.href = url;
  };

  const filteredApps = apps.filter((app) =>
    app.name.toLowerCase().includes(keyword.toLowerCase())
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div className="page">
              <h2 className="title">我的应用导航</h2>
              <input
                className="search"
                placeholder="搜索应用..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
              <div className="grid">
                {filteredApps.map((app, index) => (
                  <div
                    key={index}
                    className="appCard"
                    onClick={() => openApp(app.url)}
                  >
                    <div className="iconWrapper">
                      <div className="unicodeIcon">{app.icon}</div>
                    </div>
                    <p>{app.name}</p>
                  </div>
                ))}
              </div>
            </div>
          }
        />
        <Route path="/treehole" element={<TreeHole />} />
      </Routes>
    </BrowserRouter>
  );
}